import React from 'react';

export default function HelpFab({ onClick }) {
  return (
    <button
      className="help-fab"
      aria-label="Open help form"
      onClick={onClick}
    >
      ?
      <span className="help-fab__tip" role="tooltip">
        Get Help / Contact Support
      </span>
    </button>
  );
}